import { useMemo } from 'react';
import { useHouseholdQuery } from '../generated/graphql';
import useWeddingDayId from './useWeddingDayId';

export const useHasRsvpsCollected = (): boolean => {
  const weddingDayId = useWeddingDayId();
  const { data } = useHouseholdQuery();
  return useMemo(() => {
    if (!data) {
      return false;
    }

    return data?.households?.some(h => {
      const leader = h.people.find(person => person.isLeader)!;
      const eventInvite = leader.invitations.find(invite => invite.eventId === weddingDayId);
      return eventInvite?.rsvp !== null;
    });
  }, [data, weddingDayId]);
};
